import React from 'react';
import { copyFor } from '../../copy/copy';
import PropTypes from 'prop-types';

const FacebookIcon = props => (
    <svg width={props.width||20} height={props.height||20} 
    	viewBox={props.viewBox||"0 0 20 20"} xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'share')}</title>
        <path
            d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.793C0 19.507.494 20 1.104 20h9.58v-7.745H8.076V9.237h2.606V7.01c0-2.583 1.578-3.99 3.883-3.99 1.104 0 2.052.083 2.33.12v2.7h-1.6c-1.253 0-1.495.597-1.495 1.47v1.928h2.99l-.39 3.018h-2.6V20H18.9c.608 0 1.102-.494 1.102-1.104V1.104C20 .494 19.506 0 18.896 0z"
            fillRule="nonzero"
            fill="#3B5998"
        />
    </svg>
);

FacebookIcon.propTypes={
	width:PropTypes.number,
	height:PropTypes.number,
	viewBox:PropTypes.string,
}

export default FacebookIcon;
